<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Header -->
							<div class="page_header">Document Type List</div>
							<!-- Header -->
				
							<div class="page_main">
				
								<div class="btn_el">
									<div class="tips">
										You can search added document types by entering the document type name.
									</div>
									<div class="tips">
										· Click the "Add Document Type" button to create new document types for managing company documents.
									</div>
									<div class="tips">
										· Click the "Edit" button to modify the document type name and sort order.
									</div>
									<div class="tips">
										· After adding a new document type, please configure the approval workflow for document operations under this type.
									</div>
									<div class="tips">
										· If the document type is no longer used, click the "Delete" button. This operation cannot be undone.
									</div>
								</div>
				
				
								<!-- Search -->
								<div class="search_box">
									<div class="search_el">
										<div class="search_el_el">
											<div class="tit">
												Document Type Name
											</div>
				
											<el-input 
												v-model="query.keyword" 
												placeholder="Please enter" 
												clearable>
											</el-input>
				
										</div>
									</div>
				
				
									<div class="btn_box">
				
										<van-button 
											class="btn_el" 
											round 
											color="linear-gradient(to right, #7BC1FF, #4886FF)" 
											@click="handleClick('Add')">
											Add Document Type
										</van-button>
				
										<van-button 
											class="btn_el" 
											round 
											color="linear-gradient(to right, #7BC1FF, #4886FF)" 
											@click="search">
											Search
										</van-button>
				
									</div>
								</div>
								<!-- Search -->
				
				
								<!-- Table -->
								<div class="table_box">
				
									<el-table 
										v-loading="tableLoading" 
										:data="tableData" 
										border 
										class="table_el" 
										ref="multipleTable" 
										header-cell-class-name="table-header">
				
										<el-table-column 
											prop="id" 
											label="Operation" 
											width="100" 
											align="center">
				
											<template #default="scope">
												<div class="inline_btn">
				
													<el-button 
														type="primary" 
														size="mini" 
														@click="handleClick('Edit', scope.row)">
														Edit
													</el-button>
				
												</div>
											</template>
				
										</el-table-column>
				
				
										<el-table-column 
											prop="title" 
											label="Document Type Name" 
											:show-overflow-tooltip="true">
										</el-table-column>
				
				
										<el-table-column 
											prop="sort" 
											label="Sort Order" 
											width="100" 
											align="center" 
											:show-overflow-tooltip="true">
										</el-table-column>
				
				
										<el-table-column 
											prop="id" 
											label="Operation" 
											width="360" 
											align="center">
				
											<template #default="scope">
				
												<div class="inline_btn">
				
													<el-button 
														type="primary" 
														size="mini" 
														@click="handleClick('Configure Approval Workflow', scope.row)">
														Configure Approval Workflow
													</el-button>
				
												</div>
												<div class="inline_btn mr_l">
				
													<el-button 
														type="danger" 
														size="mini" 
														@click="handleClick('Delete', scope.row)">
														Delete
													</el-button>
				
												</div>
											</template>
										</el-table-column>
									</el-table>
									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal"
										>
										</el-pagination>
									</div>
								</div>
								<!-- Table -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { resourcesLeixingList, resourcesLeixingDel } from '@/api/docManage/configureDocControl/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components:{
		headers,
		slider
	},
	data() {
		return {
			isLoading: true,
			query: {
				keyword: '',
				sort: '',
				page: 1,
				page_size: 10
			},
			tableLoading: false,
			tableData: [],
			pageTotal: 0,  //总条数
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			resourcesLeixingList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.pageTotal = res.data.total;
					that.tableData = res.data.data;
				}else {
					
				}
			});
		},
		//搜索
		search(formName) {
			let that = this;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
			    case 'Add':
					that.$router.push({ path: '/DocControl/doctype-add-edit' });
				break;
			    case 'Edit':
					that.$router.push({ path: '/DocControl/doctype-add-edit', query: { oid: value.id } });
				break;
				case 'Configure Approval Workflow':
					that.$router.push({ path: '/DocControl/doctype-flow', query: { oid: value.id } });
				break;
				case 'Delete':
					that.$confirm('Delete this file type?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						resourcesLeixingDel({ id: value.id }).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								that.getTableData();
							}
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
			}
		},
		//取消
		cancel() {
			this.$router.back();
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		//表格
		.table_box{
			width: 100%;
			.inline_btn{
				display: inline-block;
			}
			.pagination {
				margin: 10px 0;
				text-align: right;
			}
			.mr_l{
				margin-left: 10px;
			}
		}
		//搜索
		.search_box{
			.search_el{
				display: flex;
				padding-bottom: 10px;
				.search_el_el{
					flex: 1;
				}
				.mr_r{
					margin-right: 10px;
				}
				.mr_l{
					margin-left: 10px;
				}
			}
		}
		.btn_box{
			text-align: right;
			.btn_el{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			border-radius: 6px;
			background-color: #ffb1001a;
			padding: 10px 8px;
			.tips{
				padding: 2px 0;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
::v-deep .table_box .inline_btn .el-button{
	padding: 2px 6px;
}
</style>

